<template>
  <div class="radingCenter">
    <!-- 面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务结算</el-breadcrumb-item>
      <el-breadcrumb-item>交易记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 内容 -->
    <el-card class="main" style="margin-top:20px">
      <!-- 头部查询 -->
      <div slot="header" class="clearfix">
        <el-date-picker
          size="small"
          style="width:280px"
          v-model="Time"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-select
          v-model="applyType"
          clearable
          placeholder="交易类型"
          size="small"
          style="width:140px"
        >
          <el-option label="订单应收" value="0"></el-option>
          <el-option label="柜子应收" value="5"></el-option>
        </el-select>
        <el-button
         icon="el-icon-search" 
          type="primary"
          size="small"
          @click="queryRad"
        >搜索</el-button>
      </div>
      <!-- 信息列表 -->
      <el-table :data="radData" style="width: 100%">
        <el-table-column label="#" prop="applyNo">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              style="margin-left:10px"
              @click="torading(scope.row.applyNo)"
            >交易明细</el-link>
          </template>
        </el-table-column>
        <el-table-column label="交易编号" prop="applyNo">
          <template slot-scope="scope">
            <span>{{ scope.row.applyNo }}</span>
          </template>
        </el-table-column>
        <el-table-column label="交易类型" width="110">
          <template slot-scope="scope">
            <span>{{ applyTypeText(scope.row.applyType) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户" prop="settleName"></el-table-column>
        <el-table-column label="金额" prop="realMoney">
          <template slot-scope="scope">
            <span>{{ scope.row.realMoney }} {{scope.row.currency}}</span>
          </template>
        </el-table-column>
        <el-table-column label="交易时间" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | dateformat('YYYY-MM-DD') }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 40,60, 80,100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
//引入api
import httpApi from "@/http/api";
export default {
  data() {
    return {
      radData: [], //交易订单
      Time: [], //时间
      applyType: "",
      currentPage: 1, //分页初始页
      pagesize: 20, //分页每页数据
      total: 0, //分页总数
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  methods: {
    applyTypeText(code) {
      const map = {
        "0": "订单应收",
        "5": "柜子应收"
      };
      return map[code] || code || "-";
    },
    //查询交易记录
    findList() {
      let that = this;
      let getTime = "";
      let setTime = "";
      if (that.Time[0]) {
        //转化为时间戳
        getTime = new Date(that.Time[0]).getTime() / 1000;
        setTime = new Date(that.Time[1]).getTime() / 1000;
      }
      const params = {
        page: that.currentPage,
        rows: that.pagesize,
        createStartTime: getTime,
        createEndTime: setTime
      };
      if (that.applyType) {
        params.applyType = that.applyType;
      }
      httpApi
        .findList({
          params
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.radData = res.data.data.rows;
            that.total = res.data.data.total;
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
    //搜索
    queryRad() {
      this.currentPage = 1;
      this.findList();
    },
    //跳往交易详情
    torading(applyNo) {
      this.$router.push("/transaction/" + applyNo);
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function(size) {
      this.pagesize = size;
      this.currentPage = 1;
      //每页下拉显示数据
      this.findList();
    },
    handleCurrentChange: function(currentPage) {
      this.currentPage = currentPage;
      //点击第几页
      this.findList();
    }
  },
  created() {
    this.findList();
  },
  watch: {
    Time(newVal, oldVal) {
      if (newVal == null) {
        this.Time = [];
      }
    },
    immediate: true,
    deep: true
  }
};
</script>

<style lang="less" scoped>
/deep/.el-card__body {
  padding: 0px 20px 20px;
}
.clearfix {
  text-align: left;
  margin-left: -10px;
  display: flex;
  .el-input {
    width: 150px !important;
  }
  span,
  div,
  button {
    margin-left: 20px;
  }
}
/deep/.block {
  margin-top: 20px;
  text-align: center;
}
</style>
